var monaco = require('./src/Monaco.vue')

module.exports = monaco



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/index.js
// module id = ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/index.js
// module chunks = 1